import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { OrgAppbarComponent } from '../../../layout/components/org-appbar/org-appbar.component';
import { BaseComponent } from '../../../../../core/shared/common/base.component';
import { BillingSummaryComponent } from './components/billing-summary/billing-summary.component';
import { AvailableProductsComponent } from './components/available-products/available-products.component';
import { ActiveProductsComponent } from './components/active-products/active-products.component';

const MSP_ACCOUNT_TYPE = 2;
const MMSP_ACCOUNT_TYPE = 3;

@Component({
  selector: 'app-services',
  standalone: true,
  imports: [
    CommonModule,
    OrgAppbarComponent,
    BillingSummaryComponent,
    AvailableProductsComponent,
    ActiveProductsComponent,
  ],
  templateUrl: './services.component.html',
  styleUrl: './services.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServicesComponent extends BaseComponent {
  private readonly route = inject(ActivatedRoute);

  public readonly organizationId = signal<number | null>(null);
  public readonly accountType = signal<number | null>(null);

  public readonly isMspOrMmsp = computed(() => {
    const t = this.accountType();
    return t === MSP_ACCOUNT_TYPE || t === MMSP_ACCOUNT_TYPE;
  });

  constructor() {
    super();
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      this.organizationId.set(params['organizationId'] ? +params['organizationId'] : null);
      this.accountType.set(params['account_type'] ? +params['account_type'] : null);
    });
  }
}
